module.exports = __webpack_public_path__ + "static/media/podcasts.31c7b27f.svg";